(function () {
  var buttonLogin = document.querySelector('#CustomerLoginForm .account-section--btn');
  var spamField = document.querySelector('#CustomerLoginForm #CustomerSpam');
  if (!buttonLogin || !spamField) return;

  spamField.addEventListener('change', function () {
    if (spamField.value == 12) {
      buttonLogin.disabled = false;
    }
  });

  spamField.addEventListener('keyup', function () {
    if (spamField.value == 12) {
      buttonLogin.disabled = false;
    }
  });
})();
